import {createSelector} from 'reselect';
import {getSelectedDeliveryOptionIDList} from '../../DeliveryOptionsSelectors/DeliveryOptionsSelectors';

export default createSelector(
  [getSelectedDeliveryOptionIDList],
  selectedDeliveryOptionIDList => !(selectedDeliveryOptionIDList?.includes(73)),
);
